var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 161,
    viewBox: "0 0 207 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.857 0.000976562H13.143C5.88491 0.000976562 0 5.88552 0 13.1437V147.858C0 155.116 5.88491 161.001 13.143 161.001H193.857C201.115 161.001 207 155.116 207 147.858V13.1437C207 5.88552 201.115 0.000976562 193.857 0.000976562ZM193.857 13.1437V108.728L167.955 85.1795C164.062 81.6408 158.075 81.7821 154.356 85.505L128.142 111.715L76.4553 49.9764C72.5483 45.3106 65.392 45.2648 61.4264 49.8745L13.143 105.988V13.1437H193.857ZM138 47.6437C138 37.6616 146.089 29.5721 156.071 29.5721C166.053 29.5721 174.142 37.6616 174.142 47.6437C174.142 57.6258 166.054 65.7148 156.071 65.7148C146.089 65.7152 138 57.6258 138 47.6437Z",
    fill: "#E2E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.3221c1c1477f3b814e5962cb971ceafe.svg";
export { ForwardRef as ReactComponent };